
























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import {RegionStore} from "@/modules/regions/store";
import DistrictLabel from "@/modules/regions/DistrictLabel/index.vue";
import {District} from "@/interfaces/entity";
import {toSlug} from "@/shared/services/helper/utils";

@Component({
    name: "DistrictSelector",
    components: {DistrictLabel}
})
export default class extends Vue {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';

    @Model("change", {type: Number})
    readonly districtId!: number;

    @Emit("change")
    handleChange(value?: number) {
        return value;
    }

    @Prop({required: true})
    readonly provinceId!: number;

    districts: District[] = [];

    @Watch("provinceId", {immediate: true})
    async onChangeProvinceId(val: number, oldVal: number) {
        if (!val && !oldVal) return;
        if (!val && oldVal) {
            this.districts = [];
            this.handleChange();
            return;
        }
        try {
            this.districts = await RegionStore.getDistricts(val);
            if (!this.districtId) return;
            if (this.districts.some((district: District) => district.id === this.districtId)) return;
            this.handleChange();
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ").toLowerCase()) >= 0);
    }
}
